var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.nbOfStars),function(nb,index){return _c('div',{key:index,ref:`${_vm.baseRef}`,refInFor:true,on:{"click":function($event){return _vm.ratingChanged(index)}}},[_c('font-awesome-icon',{staticClass:"fa-3x color-brand clickable",attrs:{"icon":_vm.getIcon(index)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }